/** Open state of the document assistant side panel. */
export const useCopilotPanelStore = defineStore("copilotPanel", {
  state: (): { isOpen: boolean } => {
    return { isOpen: false };
  },
  actions: {
    setIsOpen(isOpen: boolean) {
      this.isOpen = isOpen;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
});
